/* Email regex check from:
   https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript */
const validateEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const checkEmailFormat = (email) => {
  return validateEmailRegex.test(email.toLowerCase())
}
